export enum TaskMessageEnum {
  Error = 1,
  Success = 2,
}
